export default "__VITE_ASSET__Cz5SIsoi__"